import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paginate-select',
  templateUrl: './paginate-select.component.html',
  styleUrls: ['./paginate-select.component.scss']
})
export class PaginateSelectComponent implements OnInit {
  @Input() parameter: string;
  @Input() currentPage: string;
  @Input() totalPages: string;
  @Input() totalElements: string;
  @Output('update') changeParameter = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  onChange(){
    this.changeParameter.emit(this.parameter);
    return this.parameter;
}

// isOptionDisabled(optionValue: number): boolean {
//   // Calculate the total number of items based on the current page and selected option
//   const totalItems = Number(this.currentPage) * optionValue;
//   // console.log("totalItems", totalItems);
//   // console.log("currentPage", this.currentPage);
//   // console.log("parameter", this.parameter);
//   // console.log("totalPages", this.totalPages);
//   // console.log("totalElements", this.totalElements);
//   // Disable the option if the total number of items is greater than or equal to the total entries
//   // OR if the current page is the last page and the option value is greater than the remainder
//   return totalItems >= Number(this.totalElements) || (this.currentPage == this.totalPages && Number(this.totalElements) % optionValue !== 0);
// }

isOptionDisabled(optionValue: number): boolean {
  // Calculate the total number of items based on the current page and selected option
  // if(this.currentPage == this.totalPages){
  const totalItems = (Number(this.currentPage) - 1) * Number(this.parameter) + optionValue;
  // Disable the option if the total number of items is greater than or equal to the total entries
  // const totalItemsRendered = Number(this.currentPage) * Number(this.parameter);
  // let renderedError = totalItemsRendered > Number(this.totalItemsDisplay);
  // console.log("totalElements", this.totalItemsDisplay);
  // console.log("renderedError", renderedError);
  return totalItems > Number(this.totalElements);
  // }

}

}
